export default __webpack_public_path__ + "2114b47b47a7c3947c92de57e9b3b6f7.png";